/* @flow */

import { omit } from "lodash/fp";
import { ValidationError } from "yup";
import type { DDAState, Action, DDAEntry } from "../types";
import { DDAFeeAccountInformationSchema } from "../validators/schemas/ddaFeeAccount";

// Validate DDA entry against schema
export const validate = (dda: ?DDAEntry) => {
  if (!dda) {
    return "Please complete Direct Debit Agreement";
  }
  try {
    DDAFeeAccountInformationSchema.validateSync(dda, { abortEarly: false });
  } catch (error) {
    if (ValidationError.isError(error)) {
      if (error.inner && error.inner.length > 1) {
        return "Please complete Direct Debit Agreement";
      }
      return error.message;
    }
    throw error;
  }
  return undefined;
};

export const initialState: DDAState = {
  errorText: validate(null),
  values: null 
};

// Core reducer logic taking additional parameters
export const ddaReducerSwitch = (
  state: DDAState = initialState,
  action: Action = {}
): DDAState => {
  let newValues = null;
  switch (action.type) {
    case "DDA_ADD":
      newValues = {
        ...action.payload,
        id: action.payload.id
      };
      break;
      
    case "DDA_UPDATE":
      if (!state.values) {
        throw new Error("No DDA entry to update");
      }
      
      newValues = {
        ...state.values,
        ...omit(["serverSideValidationErrors"])(action.payload)
      };
      break;
    case "DDA_DELETE":
      newValues = null;
      break;
    default:
      return state;
  }

  return {
    values: newValues,
    errorText: validate(newValues)
  };
};

// Factory function that returns a configured reducer
const ddaReducer = () => (
  state: DDAState = initialState,
  action: Action
): DDAState => ddaReducerSwitch(state, action);

export default ddaReducer;